module.exports = __webpack_public_path__ + "img/newmember.f1e34f82.svg";